import { yearName, getMonthText } from '@/utils/helpers/helpFunctions';

export const masks = {
  phone: {
    mask: '+{7} (000) 000 00 00',
    lazy: true,
  },
  codeFourSymbols: {
    mask: '0000',
  },
  number: {
    mask: Number,
  },
  email: {
    mask: /^\S*@?\S*$/,
  },
  snils: { mask: '000-000-000-00' },
  inn: { mask: '000000000000' },
  passportSeries: { mask: '0000' },
  passportNumber: { mask: '000000' },
  passportProviderCode: { mask: '000-000' },
  percent: {
    mask: 'num %',
    blocks: {
      num: {
        mask: Number,
        scale: 1,
      },
    },
    lazy: false,
    commit(value: any, masked: any) {
      if (!masked._value) masked._blocks[2]._value = ' %';
      else masked._blocks[2]._value = '%';

      if (!masked.rawInputValue) {
        masked.lazy = true;
        masked.reset();
      } else {
        masked.lazy = false;
      }
    },
  },
  RUBPrice: {
    mask: 'num ₽',
    blocks: {
      num: {
        mask: Number,
        scale: 0,
        thousandsSeparator: ' ',
      },
    },
    lazy: false,
    commit(value: any, masked: any) {
      if (!masked._value) masked._blocks[2]._value = ' ₽';
      else masked._blocks[2]._value = '₽';

      if (!masked.rawInputValue) {
        masked.lazy = true;
        masked.reset();
      } else {
        masked.lazy = false;
      }
    },
  },
  dateText: {
    mask: 'num T',
    blocks: {
      num: {
        mask: Number,
        scale: 0,
      },
    },
    lazy: false,
    prepare(value: any, masked: any) {
      const fullValue = `${masked._value}${value}`;
      if (!isNaN(Number(fullValue))) masked._blocks[2].char = yearName(fullValue).split(' ')[1];
      return value;
    },
    commit(value: any, masked: any) {
      if (!masked._value) masked._blocks[2]._value = ' ' + yearName(masked.rawInputValue).split(' ')[1];
      else masked._blocks[2]._value = yearName(masked.rawInputValue).split(' ')[1];

      if (!masked.rawInputValue) {
        masked.lazy = true;
        masked.reset();
      } else {
        masked.lazy = false;
      }
    },
  },
  monthText: {
    mask: 'num T',
    blocks: {
      num: {
        mask: Number,
        scale: 0,
      },
    },
    lazy: false,
    prepare(value: any, masked: any) {
      const fullValue = `${masked._value}${value}`;
      if (!isNaN(Number(fullValue))) masked._blocks[2].char = getMonthText(fullValue).split(' ')[1];
      return value;
    },
    commit(value: any, masked: any) {
      if (!masked._value) masked._blocks[2]._value = ' ' + getMonthText(masked.rawInputValue).split(' ')[1];
      else masked._blocks[2]._value = getMonthText(masked.rawInputValue).split(' ')[1];

      if (!masked.rawInputValue) {
        masked.lazy = true;
        masked.reset();
      } else {
        masked.lazy = false;
      }
    },
  },
  birthCertificateNumber: {
    mask: '000000',
  },
};
